export default __webpack_public_path__ + "static/media/h1.fae8ae21.jpg";